<template>
  <!-- 分项能耗 -->
  <div style="position: relative;">
    <div class="con">
      <div class="Files-top">
        <div class="ic-left">
          <span>分项能耗</span>
        </div>
        <div class="btns">
          <el-button type="primary" size="mini" @click="exportList" class="last-el-button">导出</el-button>
        </div>
      </div>
      <div class="search-input-btn">
        <div class="input-small myinput">
          <span>分项类型：</span>
          <el-select v-model="energyType" placeholder="请选择" style="width:160px">
            <el-option v-for="item in typeOptions" :key="item.appTypeNo" :label="item.name" :value="item.appTypeNo">
            </el-option>
          </el-select>
        </div>
        <div class="input-small myinput" style="margin:0px 20px;">
          <span>时间：</span>
          <el-select v-model="timeType" placeholder="请选择" style="width: 160px;" @change="timeType_fn">
            <el-option label="日" value="DAY"> </el-option>
            <el-option label="月" value="MONTH"> </el-option>
            <el-option label="年" value="YEAR"> </el-option>
          </el-select>
        </div>
        <div class="input-small">
          <el-date-picker class="picker" v-model="dateValue" type="date" placeholder="请选择日期" v-if="dateType == 'DAY'"
            :picker-options="pickerOptions"></el-date-picker>
          <el-date-picker class="picker" v-model="dateValue" type="month" placeholder="请选择月份" v-if="dateType == 'MONTH'"
            :picker-options="pickerOptions"></el-date-picker>
          <el-date-picker class="picker" v-model="dateValue" type="year" placeholder="请选择年份" v-if="dateType == 'YEAR'"
            :picker-options="pickerOptions"></el-date-picker>
        </div>
        <el-button type="primary" size="mini" plain @click="getList" class="search-btn">查询</el-button>
      </div>




      <!-- 第二层 -->
      <div class="two-echart">
        <div class="echart echart1">
          <div class="echart-title">分项-综合用能--{{dateType | timerType_fn}}统计</div>
          <div id="echart"></div>
        </div>
        <div class="echart echart2">
          <div class="echart-title">分项-综合用能--{{dateType | timerType_fn}}分布</div>
          <div id="echart2" style="width: 100%;height: 320px;"></div>
        </div>

      </div>
      <!-- 建筑分类实时总能耗为： -->
      <div class="table_t" id="table_t">
        <div class="echart-title">分项分类实时总能耗为：<span>{{energyTotal | Total_fn}} {{energyType | energyType_fn}}</span>
        </div>
        <div class="comtent">
          <el-table stripe :data="tableData" border style="width: 100%" max-height="350">
            <template slot="empty">
              <span class="noData">
                <img src="../../../assets/noData.png" alt="暂无数据">
                <span class="text">暂无数据</span>
              </span>
            </template>
            <el-table-column prop="date" align="center" label="建筑"> </el-table-column>
            <el-table-column prop="name" align="center" label="实时总能耗"> </el-table-column>
            <el-table-column v-for="(item,index) in columns" :key='index' :prop="item.key" :label="item.name"
              :align="item.al"> </el-table-column>
          </el-table>
        </div>

      </div>
    </div>
    <!-- 遮罩层 -->
    <div class="mask" v-if="isMask">
      <i class="el-icon-loading" style="color:#409eff;font-size:60px"></i>
    </div>
    <downloadTable ref="downloadTable"></downloadTable>
  </div>
</template>

<script>
  import * as echarts from "echarts";
  import $ from 'jquery';
  import {findAllSubentry} from "../../../api/energySubentry";
  import {getSubentryEnergy} from "../../../api/overView";
  import downloadTable from '@/components/module/downloadTable/downloadTable.vue'
  var myChart,myChart2;
  export default {
    components: {
      downloadTable
    },


    data () {
      return {
        energyTotal: 0,
        energyType: "36",
        typeOptions: [],
        timeType: "DAY",
        dateValue: "",
        dateType: "DAY",
        nowArea: {},
        isMask: false,//遮罩层
        columns: [], //表格
        Totals: [],
        loading: false,
        tableData: [],
        middleData: {
          legend: {
            // data: ["1号建筑", "2号建筑", "3号建筑", "4号建筑",],
            data: [],
            top: 275,
            type: 'scroll',
            icon: "circle", //  这个字段控制形状  类型包括 circle，rect ，roundRect，triangle，diamond，pin，arrow，none
            itemWidth: 10, // 设置宽度
            itemHeight: 10, // 设置高度
            textStyle: {
              lineHeight: 56,
              fontSize: 14
            },
            itemGap: 20 // 设置间距
          },
          grid: {
            top: "12% ",
            left: 52,
            right: 12,
            bottom: 60
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // Use axis to trigger tooltip
              type: "shadow" // 'shadow' as default; can also be 'line' or 'shadow'
            }
          },
          toolbox: {
            show: true,
            showTitle: true, // 隐藏默认文字，否则两者位置会重叠
            right: '2%',
            top: '-2%',
            feature: {
              magicType: {
                type: ['line','bar'],title: {
                  line: '切换为折线图',
                  bar: '切换为柱状图',
                }
              },
              saveAsImage: {
                show: true,
                title: '下载图片'
              },
              // dataView: { show: true, readOnly: true, lang: ['', '关闭'] },
            },
            tooltip: { // 和 option.tooltip 的配置项相同
              show: false,
              formatter: function(param) {
                return '<div>'+param.title+'</div>'; // 自定义的 DOM 结构
              },
              backgroundColor: '#fff',
              textStyle: {
                fontSize: 12,
              },
              extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);' // 自定义的 CSS 样式
            }
          },
          color: ["#60ACF2",'#6071F2','#FBD437','#36CBCB','#F56C6C','#67C23A','#409EFF','#E6A23C','#909399'],

          xAxis: {
            splitLine: {
              //网格线
              show: true
            },
            splitArea: {
              //坐标轴在 grid 区域中的分隔区域，默认不显示。
              interval: "auto",
              show: false, //是否显示分隔区域
              areaStyle: {
                color: ["rgba(250,250,250,0.3)","rgba(200,200,200,0.3)"], //分隔区域颜色。分隔区域会按数组中颜色的顺序依次循环设置颜色。默认是一个深浅的间隔色。
                shadowColor: "red", //阴影颜色
                shadowOffsetX: 0, //阴影水平方向上的偏移距离。
                shadowOffsetY: 0, //阴影垂直方向上的偏移距离
                shadowBlur: 10, //图形阴影的模糊大小。
                opacity: 1 //图形透明度。支持从 0 到 1 的数字，为 0 时不绘制该图形
              }
            },
            type: "category",
            axisTick: {
              show: false
            },
            axisLabel: {
              interval: 0,
              rotate: 0,
              inside: false
            },
            axisLine: {
              show: false
            },
            z: 99,
            data: [
              "00：00",
              "00：15",
              "00：30",
              "00：45",
              "01：00",
              "01：15",
              "01：30",
              "01：45",
              "02：00",
              "02：15",
              "02：30",
              "03：00",
            ]
          },
          yAxis: {
            type: "value"
          },
          series: []
        },
        options: [
          {
            value: "date",
            label: "日"
          },
          {
            value: "month",
            label: "月"
          },
          {
            value: "year",
            label: "年"
          }
        ],
        options2: {
          tooltip: {
            trigger: "item"
          },
          legend: {
            data: [],
            top: 292,
            width: 360,
            type: 'scroll',
            icon: "circle", //  这个字段控制形状  类型包括 circle，rect ，roundRect，triangle，diamond，pin，arrow，none
            itemWidth: 12, // 设置宽度
            itemHeight: 12, // 设置高度
            textStyle: {
              lineHeight: 20,
              fontSize: 14
            },
            itemGap: 20, // 设置间距

          },
          label: {
            alignTo: "edge",
            formatter: "{name|{b}}\n{time|{c}}",
            minMargin: 5,
            edgeDistance: 10,
            lineHeight: 15,
            rich: {
              time: {
                fontSize: 10,
                color: "#999"
              }
            }
          },


          color: ["#60acf2","#4ecb73","#6071f2","#36cbcb"],
          series: [
            {
              name: "分项用能分析",
              type: "pie",
              radius: "55%",
              center: ["50%","50%"],
              itemStyle: {
                borderColor: "#fff",
                borderWidth: 1
              },
              data: [],
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)"
                }
              }
            }
          ]
        },
        pickerOptions: {
          disabledDate (time) {
            return time.getTime()>Date.now();
          },

        },
        value: [],
        value2: [],
        value3: "date",
        text: '日',
        value4: [new Date(),new Date()],
        EnergyTypes: [],//类别
        BuildingTypes: [],//能源类型
        dayData: [],
        monthData: [],
        yearData: [],
        additional: [],
        timerDate: 0
      };
    },
    computed: {

      nowBuilding () {//当前建筑
        return this.$store.cacheStore.state.setBuilding;
      }
    },
    filters: {
      guolv: function(v) {
        if(v) {
          return v.toFixed(2)
        } else {
          return '-'
        }
      },
      //类型 DAY(日)  MONTH(月) YEAR(年)
      timerType_fn (val) {
        if(val=='DAY') {
          return "日"
        } else if(val=='MONTH') {
          return "月"
        } else {
          return "年"
        }
      },
      //保留俩位小数点
      Total_fn (val) {
        return val.toFixed(2)
      },
      energyType_fn (val) {
        var d=''
        if(val=="36") {
          d="kw·h"
        } else if(val=="002") {
          d='t'
        } else if(val=="361") {
          d="m³"
        }
        return d
      }
    },
    watch: {
      energyType (val) {
        if(val=="36") {
          this.options2.label.formatter="{name|{b}}\n{time|{c}kwh}"
        } else if(val=="002") {
          this.options2.label.formatter="{name|{b}}\n{time|{c}t}"
        } else if(val=="361") {
          this.options2.label.formatter="{name|{b}}\n{time|{c}m³}"
        }
      },
      nowBuilding (val) {

        this.nowArea=val
        //  this.temp_fn(this.timerType)
      },
    },
    mounted () {
      this.nowArea=this.$store.cacheStore.state.setBuilding
      var date=new Date()
      // var today = new Date(date.getFullYear()+'-'+date.getMonth()+1+'-'+date.getDate())
      var str=date.getFullYear()+'-'+(date.getMonth()+1)+'-'+date.getDate()
      var today=new Date(str)
      this.dateValue=today
      this.timerDate=0
      this.timerDate+=1
      for(let i=1;i<=31;i++) {
        if(i<=24) {

          this.dayData.push(i>9? i+':00':'0'+i+':00')
        }
        if(i<=12) {
          this.yearData.push(i+'月')
        }
        this.monthData.push(i+'号');
      }
      this.middleData.xAxis.data=this.dayData;
      this.init();//echart图
      this.getType()


    },
    methods: {
      // 下载excel
      exportList () {
        let time=new Date();
        let year=time.getFullYear();
        let month=time.getMonth()+1;
        let day=time.getDate();
        var type=this.typeOptions.filter(item => item.appTypeNo==this.energyType)
        var timeType=""
        if(this.timeType=='DAY') {
          timeType="日"
        } else if(this.timeType=='MONTH') {
          timeType="月"
        } else {
          timeType="年"
        }
        const tHeader=['能源区域',this.nowBuilding.name,'分项类型',type[0].name,'周期',timeType,"查询时间",this.date_format_fn(this.dateValue)];

        //  this.export2Excel(tHeader,this.tableData,year + "-" + month + "-" + day + '-能耗排名');
        this.$refs.downloadTable.export2Excel(tHeader,this.tableData,year+"-"+month+"-"+day+'-分项能耗','#table_t')
      },
      //获取分项类型下拉框
      getType () {
        findAllSubentry().then(res => {
          if(res.code==200) {
            this.typeOptions=res.data
            this.energyType=res.data[0].appTypeNo

            this.getList()
          }
        })


      },
      //获取数据
      getList () {
        if(this.dateValue=='') {
          this.$message({message: `请选择时间`,type: 'warning'});
          return
        }
        if(this.timerDate==1) {
          // var dateTimer =  (this.dateValue).getTime() - 28800000
          var dateTimer=(this.dateValue).getTime()
        } else {
          var dateTimer=(this.dateValue).getTime()
        }
        var d={
          'areaId': this.nowArea.id,
          'subentryType': this.energyType,
          'date': dateTimer,
          'timeType': this.timeType,
        }
        // console.log(d);
        this.isMask=true
        this.timerDate=0
        this.energyTotal=0
        getSubentryEnergy(d).then(res => {
          if(res.code==200) {

            if(this.timeType=='DAY') {
              this.middleData.xAxis.data=this.dayData;
              this.additional=this.dayData
            } else if(this.timeType=='MONTH') {
              this.middleData.xAxis.data=this.monthData;
              this.additional=this.monthData
            } else if(this.timeType=='YEAR') {
              this.middleData.xAxis.data=this.yearData;
              this.additional=this.yearData
            }
            //区域分布
            this.squipment_fn(res.data.squipmentRatio[0])
            //区域统计
            this.subAreaConsumptionVo_fn(res.data.subSubentryConsumptionVOS)
            this.isMask=false;
          } else {
            this.isMask=false;
            this.$message({message: `获取失败${res.message}`,type: 'error'});
          }



        })
      },
      //处理区域分布
      squipment_fn (val) {
        this.options2.legend.data=[];
        this.options2.series[0].data=[];
        for(var key in val) {
          this.options2.legend.data.push(key);
          this.options2.series[0].data.push({
            value: val[key],
            name: key,
          });
        }
        myChart2.setOption(this.options2,true);
      },
      //处理区域统计
      subAreaConsumptionVo_fn (val) {
        this.middleData.legend.data=[]
        this.middleData.series=[]
        this.tableData=[]
        this.columns=[]
        this.tableData=[{
          date: "检测点",
          name: "总能耗",
        }]


        val.forEach((item,index) => {
          this.middleData.legend.data.push(item.subentryName)
          this.middleData.series.push({
            name: item.subentryName,
            data: [],
            type: "bar",
            stack: 'total',
            emphasis: {
              focus: 'series'
            },
            barWidth: 25 //柱图宽度
          })
          this.tableData.push({
            'date': item.subentryName,
            'name': item.total,
          })
          this.energyTotal+=item.total
          var i=0
          for(let key in item.timeConsumption[0]) {
            this.middleData.series[index].data.push(item.timeConsumption[0][key])

            this.tableData[index+1][key]=(item.timeConsumption[0][key])
            this.tableData[0][key]=this.additional[i]
            if(index==0) {
              this.columns.push({
                'name': this.additional[i],
                'key': key,
                'al': 'center'
              })
            }
            i++

          }

        })
        this.tableData.shift()
        myChart.setOption(this.middleData,true);
        //  console.log("this.middleData",this.middleData);



      },
      //时间类型变化
      timeType_fn (val) {
        this.dateType=val
        this.dateValue=""
      },

      //初始化echart图
      init () {
        // 建筑-综合用能-日统计
        myChart=echarts.init(document.getElementById("echart"));
        myChart.setOption(this.middleData);
        myChart.resize({height: 320});
        // 建筑-综合用能-日分布
        myChart2=echarts.init(document.getElementById("echart2"));
        myChart2.setOption(this.options2);
        //浏览器窗口发生变化时，重置报表大小
        $(window).resize(function() {
          myChart.resize({height: 320});
          myChart2.resize();
        });
      },


      // 当月最后一天
      currentMonthLast () {
        var date=this.value4||new Date();
        var currentMonth=date.getMonth();
        var nextMonth=++currentMonth
        var nextMonthFirstDay=new Date(date.getFullYear(),nextMonth,1)
        var oneDay=1000*60*60*24
        date=new Date(nextMonthFirstDay-oneDay)
        var year=date.getFullYear()
        var month=date.getMonth()+1
        var day=date.getDate()
        if(day<10) {
          day='0'+day
        }
        if(month<10) {
          month='0'+month
        }
        return year+'-'+month+'-'+day
      },
      // 转换时间戳
      date_format_fn (value) {
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
        let strDate=Y+M+D+h+m+s;
        return `'${strDate}'`
      },


    }
  };
</script>

<style lang="scss" scoped>
  .mask {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2020;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .con {
    width: 100%;
    height: 100%;
    background-color: #fff;
    padding:12px 20px;
    box-sizing: border-box;
  }

  .two-echart {
    width: 100%;
    height: 305px;
    display: flex;

    .echart1 {
      width: 75%;
      border-right: 1px solid #e6e6e6;
    }

    .echart2 {
      width: 25%;
    }
  }

  .table_t {
    box-sizing: border-box;
    position: relative;
    margin-top: 35px;
    border-top: 1px solid #e6e6e6;

    .echart-title {
      top: 15px;

      span {
        font-weight: bolder;
        font-size: 16px;
        color: #FF7C1D;
      }
    }

    .comtent {
      margin-top: 53px;
    }
  }


  .echart-title {
    font-size: 16px;
    position: absolute;
    top: -2px;
    left: 50%;
    transform: translateX(-50%);
    color: #666666;
  }

  .echart {
    height: 315px;
    box-sizing: border-box;
    position: relative;
    margin-top: 5px;


  }
</style>